module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/article-task-743e7866e63a026e70db96a7cac59232.svg";